"use client";

import _toConsumableArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { ComboboxItemValueContext, useComboboxScopedContext } from "../__chunks/3LH6HMTR.js";
import "../__chunks/APGXEJ2Q.js";
import "../__chunks/G4PVPWEW.js";
import "../__chunks/COWZSPJ7.js";
import "../__chunks/CMXOY7UW.js";
import "../__chunks/JDEWEW7S.js";
import { createElement, createHook, forwardRef } from "../__chunks/7FZLUSKW.js";
import { useStoreState } from "../__chunks/CTKPPFRS.js";
import "../__chunks/HNHAUIIY.js";
import "../__chunks/SK3NAZA3.js";
import { __objRest, __spreadValues } from "../__chunks/3YLGPPWQ.js";

// src/combobox/combobox-item-value.tsx
import { toArray } from "@ariakit/core/utils/array";
import { normalizeString, removeUndefinedValues } from "@ariakit/core/utils/misc";
import { useContext, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
var TagName = "span";
function normalizeValue(value) {
  return normalizeString(value).toLowerCase();
}
function getOffsets(string, values) {
  var offsets = [];
  var _iterator = _createForOfIteratorHelper(values),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var value = _step.value;
      var pos = 0;
      var length = value.length;
      while (string.indexOf(value, pos) !== -1) {
        var index = string.indexOf(value, pos);
        if (index !== -1) {
          offsets.push([index, length]);
        }
        pos = index + 1;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return offsets;
}
function filterOverlappingOffsets(offsets) {
  return offsets.filter(function (_ref, i, arr) {
    var _ref2 = _slicedToArray(_ref, 2),
      offset = _ref2[0],
      length = _ref2[1];
    return !arr.some(function (_ref3, j) {
      var _ref4 = _slicedToArray(_ref3, 2),
        o = _ref4[0],
        l = _ref4[1];
      return j !== i && o <= offset && o + l >= offset + length;
    });
  });
}
function sortOffsets(offsets) {
  return offsets.sort(function (_ref5, _ref6) {
    var _ref7 = _slicedToArray(_ref5, 1),
      a = _ref7[0];
    var _ref8 = _slicedToArray(_ref6, 1),
      b = _ref8[0];
    return a - b;
  });
}
function splitValue(itemValue, userValue) {
  if (!itemValue) return itemValue;
  if (!userValue) return itemValue;
  var userValues = toArray(userValue).filter(Boolean).map(normalizeValue);
  var parts = [];
  var span = function span(value) {
    var autocomplete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return /* @__PURE__ */jsx("span", {
      "data-autocomplete-value": autocomplete ? "" : void 0,
      "data-user-value": autocomplete ? void 0 : "",
      children: value
    }, parts.length);
  };
  var offsets = sortOffsets(filterOverlappingOffsets(
  // Convert userValues into a set to avoid duplicates
  getOffsets(normalizeValue(itemValue), new Set(userValues))));
  if (!offsets.length) {
    parts.push(span(itemValue, true));
    return parts;
  }
  var _offsets$ = _slicedToArray(offsets[0], 1),
    firstOffset = _offsets$[0];
  var values = [itemValue.slice(0, firstOffset)].concat(_toConsumableArray(offsets.flatMap(function (_ref9, i) {
    var _ref10 = _slicedToArray(_ref9, 2),
      offset = _ref10[0],
      length = _ref10[1];
    var _a;
    var value = itemValue.slice(offset, offset + length);
    var nextOffset = (_a = offsets[i + 1]) == null ? void 0 : _a[0];
    var nextValue = itemValue.slice(offset + length, nextOffset);
    return [value, nextValue];
  })));
  values.forEach(function (value, i) {
    if (!value) return;
    parts.push(span(value, i % 2 === 0));
  });
  return parts;
}
var useComboboxItemValue = createHook(function useComboboxItemValue2(_a) {
  var _b = _a,
    store = _b.store,
    value = _b.value,
    userValue = _b.userValue,
    props = __objRest(_b, ["store", "value", "userValue"]);
  var context = useComboboxScopedContext();
  store = store || context;
  var itemContext = useContext(ComboboxItemValueContext);
  var itemValue = value != null ? value : itemContext;
  var inputValue = useStoreState(store, function (state) {
    return userValue != null ? userValue : state == null ? void 0 : state.value;
  });
  var children = useMemo(function () {
    if (!itemValue) return;
    if (!inputValue) return itemValue;
    return splitValue(itemValue, inputValue);
  }, [itemValue, inputValue]);
  props = __spreadValues({
    children: children
  }, props);
  return removeUndefinedValues(props);
});
var ComboboxItemValue = forwardRef(function ComboboxItemValue2(props) {
  var htmlProps = useComboboxItemValue(props);
  return createElement(TagName, htmlProps);
});
export { ComboboxItemValue, useComboboxItemValue };